"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterChildren = _interopRequireDefault(require("../../../utils/Children/filterChildren"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TableTitle = function TableTitle(props) {
  var className = props.className,
      id = props.id,
      secondary = props.secondary,
      onSecondaryTitleClick = props.onSecondaryTitleClick,
      style = props.style,
      secondaryStyle = props.secondaryStyle;

  var tableTitle = function tableTitle() {
    return (0, _classnames["default"])({
      'ui-table-title': true
    }, className);
  };

  var newChildren = (0, _filterChildren["default"])(props.children);
  return /*#__PURE__*/_react["default"].createElement("caption", {
    id: id,
    className: tableTitle(),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "ui-table-title__primary-title"
  }, newChildren), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ui-table-title__secondary"
  }, onSecondaryTitleClick ? /*#__PURE__*/_react["default"].createElement("a", {
    className: "ui-table-title__secondary-title secondary-title--link",
    type: "link",
    onClick: onSecondaryTitleClick,
    style: secondaryStyle,
    role: "link",
    tabIndex: 0
  }, secondary) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "ui-table-title__secondary-title",
    style: secondaryStyle
  }, secondary)));
};

TableTitle.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,

  /** className for reference */
  className: _propTypes["default"].string,

  /** Secondary text or node */
  secondary: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** On Secondary text click function if clickable */
  onSecondaryTitleClick: _propTypes["default"].func,

  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,

  /** Override the inline-styles of the secondary title element || Not Recommended */
  secondaryStyle: _propTypes["default"].object,

  /**
   * children props for content inside
   * @ignore
   */
  children: _propTypes["default"].node
};
TableTitle.defaultProps = {
  id: '',
  className: '',
  children: [],
  onCellClick: null,
  style: {},
  secondaryStyle: {},
  onSecondaryTitleClick: null,
  secondary: ''
};
var _default = TableTitle;
exports["default"] = _default;